import {Box} from '@mui/material';
import styles from './styles.module.scss';
import AurWorkspaceChip from './AurWorkspaceChip';

type AurWorkspaceChipListProps<T> = {
  items: T[];
  itemKey: keyof T;
  itemLabel: keyof T;
  chipClassName?: string;
  onClick?: () => void;
  onDelete?: (deletedItem: T, items?: T[]) => void;
};

const AurWorkspaceChipList = <T,>({
  items = [],
  itemKey,
  itemLabel,
  chipClassName,
  onClick,
  onDelete,
}: AurWorkspaceChipListProps<T>) => {
  const handleDelete = (deletedItem: T) => {
    const remainingItems = items.filter(
      (item) => item[itemKey] !== deletedItem[itemKey]
    );
    onDelete?.(deletedItem, remainingItems);
  };

  return (
    <Box
      data-testid={'chiplist-container'}
      className={styles.AurBasicChipsContainer}
    >
      {items.map((item) => (
        <AurWorkspaceChip
          key={itemKey as string}
          item={item}
          itemKey={itemKey}
          itemLabel={itemLabel}
          className={chipClassName}
          onClick={onClick}
          onDelete={
            onDelete
              ? (deletedItem) => {
                  handleDelete(deletedItem);
                }
              : undefined
          }
        />
      ))}
    </Box>
  );
};

export default AurWorkspaceChipList;
